import usePresentPage from 'client/hooks/usePresentPage'
import {
  getGlobalMobileTextFontSize,
  getGlobalTextFontSize,
} from 'client/reducers/pageReducer'
import { useWebsiteSettings } from 'client/store'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useFontSize = ({
  fontSize,
  mobileFontSize,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontSize?: number
  mobileFontSize?: number
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalFontSize = usePresentPage(getGlobalTextFontSize) as string
  const typographySelector = typographySelectorMap[typographyType]
  const {
    fontSize: websiteGlobalFontSize,
    mobileFontSize: websiteGlobalMobileFontSize,
  } = useWebsiteSettings(typographySelector) || {}
  const pageGlobalMobileFontSize = usePresentPage(
    getGlobalMobileTextFontSize,
  ) as string

  const globalFontSize =
    Number.parseInt(pageGlobalFontSize) || websiteGlobalFontSize
  const globalMobileFontSize =
    Number.parseInt(pageGlobalMobileFontSize) || websiteGlobalMobileFontSize

  return {
    calculatedFontSize: getCalculatedProperty({
      desktopProperty: fontSize,
      mobileProperty: mobileFontSize,
      globalDesktopProperty: globalFontSize,
      globalMobileProperty: globalMobileFontSize,
    }),
    globalFontSize: globalFontSize,
    globalMobileFontSize: globalMobileFontSize,
  }
}
